export interface IOption {
  label: string;
  value: string | boolean;
}

export const unitTypes: IOption[] = [
  { label: "TRA", value: "TRA" },
  { label: "TC20", value: "TC20" },
  { label: "TC30", value: "TC30" },
  { label: "CON20", value: "CON20" },
  { label: "CON30", value: "CON30" },
  { label: "CON40", value: "CON40" },
  { label: "CON45", value: "CON45" },
  { label: "SWAP40", value: "SWAP40" },
  { label: "SWAP45", value: "SWAP45" },
];

export const packageTypes: IOption[] = [
  { label: "CLI", value: "CLI" },
  { label: "COI", value: "COI" },
  { label: "BAG", value: "BAG" },
  { label: "CTN", value: "CTN" },
  { label: "DRU", value: "DRU" },
  { label: "PLL", value: "PLL" },
  { label: "PALL", value: "PALL" },
  { label: "PACK", value: "PACK" },
];

export const customsDocumentTypes: IOption[] = [
  { label: "T1", value: "T1" },
  { label: "C", value: "C" },
  { label: "T2", value: "T2" },
  { label: "EU", value: "EU" },
  { label: "EX", value: "EX" },
  { label: "N", value: "N" },
  { label: "TIR", value: "TIR" },
  { label: "ATA", value: "ATA" },
  { label: "TR", value: "TR" },
  { label: "IR", value: "IR" },
  { label: "CMR", value: "CMR" },
  { label: "EX1", value: "EX1" },
  { label: "EX2", value: "EX2" },
  { label: "NONE", value: "NONE" },
];

export const cranableTypes: IOption[] = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const adrTypes: IOption[] = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];
